import Hero from "@/components/Hero";
import Solution from "@/components/Solution";
import Benefits from "@/components/Benefits";
import Features from "@/components/Features";
import Dashboard from "@/components/Dashboard";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Hero />
      <Solution />
      <Benefits />
      <Features />
      <Dashboard />
      <Footer />
    </div>
  );
};

export default Index;
